import * as React from 'react';
const SvgEAvatar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={73}
    height={72}
    fill="currentColor"
  >
    <path d="m38.287 24.48-2.02 6.902h12.798l-2.41 8.446h-12.8l-2.233 7.726h17.16L46.3 56H19l11.63-40H58l-2.482 8.446h-17.23z" />
  </svg>
);
export default SvgEAvatar;
